import React, { useId, useState } from 'react'

interface CollapsibleFormGroupProps {
  title: string
  initialOpen?: boolean
}

function CollapsibleFormGroup({
  title,
  initialOpen = true,
  children,
}: React.PropsWithChildren<CollapsibleFormGroupProps>) {
  const [isOpen, setIsOpen] = useState(initialOpen)
  const bodyId = useId()

  return (
    <div className="hc-form__group">
      <button
        type="button"
        className="hc-form__group-heading"
        aria-expanded={isOpen}
        aria-controls={bodyId}
        onClick={() => setIsOpen((open) => !open)}
      >
        <span className="hc-form__group-heading-label">{title}</span>
        <span className="hc-form__group-heading-rule" />
        <i
          className={`fa ${isOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`}
          aria-hidden="true"
        />
      </button>
      <div id={bodyId} className={isOpen ? '' : 'd-none'}>
        {children}
      </div>
    </div>
  )
}

CollapsibleFormGroup.defaultProps = {
  initialOpen: true,
}

export default CollapsibleFormGroup
